// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"72c6910a","364":"f06fc26b","406":"ddccf709","537":"ae07b585","890":"98ca1d20"}[chunkId] + ".css";
};